import { axios } from "../../../packs/axios";
import { anylinkAPI } from "./anylinkAPI";

const communicationType = "campaigns";

export const campaignAPI = {
  fetch(campaignId) {
    return axios.get(`/api/v3/campaigns/${campaignId}`)
      .then((resp) => resp.data);
  },
  /**
   * Get all anylinks from a campaign
   * @param {number} campaignId
   * @returns {array} Array of anylinks ordered by priority
   */
  getAnyLinks(campaignId) {
    return anylinkAPI.getAnyLinks(communicationType, campaignId)
  },
  patch(campaignId, frag) {
    return axios.patch(`/api/v3/campaigns/${campaignId}`, {
      campaign: frag
    }).then((resp) => resp.data)
  },
  patchRewards(rewardId, frag) {
    return axios.patch(`/api/v3/rewards/${campaignId}`, frag)
      .then((resp) => resp.data)
  },
  /**
   * Post Create Campaign with Segments
   * @constructor
   * @param {number} campaignId - The Campaign ID
   * @param {string} clickType - The type of click (campaign_click // no_campaign_click)
   * @returns {object} {edit_path: ""} containing URL edit_path to redirect the user to
  **/
  postCreateCampaignWithSegments(campaignId, clickType){
    return axios.post(`/api/v3/campaigns/${campaignId}/create_campaign_with_segments?click_type=${clickType}`).then(resp => resp.data);
  },
  /**
   * PUT to update anyLinks for a campaign
   * @param {number} campaignId
   * @param {array} anyLinks
   * @returns {object} status code 200 if successful or error
   */
  putUpdateAnyLinks(campaignId, anyLinks) {
    return anylinkAPI.putUpdateAnyLinks(communicationType, campaignId, anyLinks)
  },
  updateMessage(campaignId, text) {
    return axios.patch(`/api/v3/campaigns/${campaignId}/update_sms_content`, {
      text
    }).then((resp) => resp.data);
  }
}
